import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { DisconnectCloudDialog } from '@/components/disconnect-cloud-dialog';
import { DisconnectCoexistenceDialog } from '@/components/disconnect-coexistence-dialog';
import type { Channel } from '@/types/channel';

interface DangerZoneProps {
  channel: Channel;
  onDisconnected: () => void;
}

export function DangerZone({
  channel,
  onDisconnected,
}: DangerZoneProps) {
  const [dialogOpen, setDialogOpen] = useState(false);

  const isCoexistence = channel.connectionType === 'coexistence';

  return (
    <div role="region" aria-label="Danger zone">
      <div className="rounded-lg border border-destructive/30 p-6">
        <h2 className="text-lg font-semibold text-destructive">Danger Zone</h2>
        <p className="mt-2 text-sm text-muted-foreground">
          Disconnecting stops delivery on this channel. It stays here as
          history and you can reconnect it anytime.
        </p>
        <Button
          variant="destructive"
          className="mt-4"
          onClick={() => setDialogOpen(true)}
        >
          Disconnect Channel
        </Button>
      </div>

      {isCoexistence && channel.type === 'whatsapp' ? (
        <DisconnectCoexistenceDialog
          open={dialogOpen}
          onOpenChange={setDialogOpen}
          channel={channel}
          onDisconnected={onDisconnected}
        />
      ) : (
        <DisconnectCloudDialog
          open={dialogOpen}
          onOpenChange={setDialogOpen}
          channel={channel}
          onDisconnected={onDisconnected}
        />
      )}
    </div>
  );
}
